import { faBarcode, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, Button, Form, FormGroup, Modal, Row } from "react-bootstrap";
import { read, utils } from "xlsx";
import { Fragment, useEffect, useRef, useState } from "react";
import { Check2Square, DashCircle, ExclamationTriangle, PlusSquare, Printer } from "react-bootstrap-icons";
import { getPrintTemplateList, inputIsAllEnglish, loadPrintReport, savePrintReport } from "../../store/api/CommonFunctions";
import icons8 from "../../content/images/icons8-go-back-24.png";
import backWhite from "../../content/images/icons8-go-back-White.png";

export default function ModalBarcodePrint(props) {
    const { popData, setPopData } = props;
    const report = new window.Stimulsoft.Report.StiReport();
    report.info.zoom = 0.5;
    const { show } = popData;
    const jsonData = useRef([]);
    const reportName = useRef("Barcode_" + Date.now());
    const [modalSize, setModalSize] = useState("");
    const [showInputFile, setShowInputFile] = useState(false);
    const [showPrint, setShowPrint] = useState(false);
    const [error, setError] = useState(null);
    const inputNewReportName = useRef();
    const inputPrintCount = useRef();
    const inputBarcodeData = useRef();
    const [showNewPrint, setShowNewPrint] = useState(false);
    const [printTemplates, setPrintTemplates] = useState([]);
    function getUploadedFile(e) {
        const f = e.currentTarget.files[0];
        jsonData.current = [];
        f.arrayBuffer().then(data => {
            const exclData = read(data);
            const sheetName = exclData.SheetNames[0];
            const exclObject = utils.sheet_to_json(exclData.Sheets[sheetName], { defval: null });
            if (exclObject?.length > 0) {
                const objectKeys = Object.keys(exclObject[0]);
                if (objectKeys?.length > 0) {
                    for (let j in exclObject) {
                        const data = {};
                        const obj = exclObject[j];
                        data.BarCodeData = obj[objectKeys[0]];
                        if (objectKeys.length > 1) {
                            data.Name = obj[objectKeys[1]];
                        }
                        if (objectKeys.length > 2) {
                            data.Model = obj[objectKeys[2]];
                        }
                        if (objectKeys.length > 3) {
                            data.LableName = obj[objectKeys[3]];
                        }
                        if (objectKeys.length > 4) {
                            data.Serial = obj[objectKeys[4]];
                        }
                        if (objectKeys.length > 5) {
                            data.QRCodeData = obj[objectKeys[5]];
                        }
                        jsonData.current.push(data);
                    }
                }
            }
        });
    }
    function close() {
        setError(null);
        setPopData({ show: false });
        setModalSize("");
        jsonData.current = [];
    }
    function closePrint() {
        setShowPrint(false);
        setModalSize("");
    }
    function addNewBarcodePrint() {
        setError(null);
        let printName = inputNewReportName.current.value;
        if (printName === "") {
            setError("نام چاپ نمی تواند خالی باشد");
            return;
        }
        if (!inputIsAllEnglish(printName)) {
            setError("نام فایل چاپ باید انگلیسی باشد");
            return;
        }
        printName = "Barcode_" + printName;
        const newReport = new window.Stimulsoft.Report.StiReport();
        newReport.reportName = printName;
        newReport.reportAlias = printName;
        const jsonStr = newReport.saveToJsonString();
        const onSuccess = () => {
            getPrintTemplateList("Barcode", setPrintTemplates);
            setShowNewPrint(false);
        }
        savePrintReport(printName, jsonStr, onSuccess);
    }
    function print(e) {
        const loadReport = async (res) => {

            report.load(res);
        }
        const onGetReport = (res) => {
            if (res.Message) {
                return;
            }
            loadReport(res).then(() => {
                setModalSize("xl");
                setShowPrint(true);
                const dataSet = new window.Stimulsoft.System.Data.DataSet("ds" + reportName.current);
                const printCount = Number(inputPrintCount.current.value);
                const printData = [];
                if (!showInputFile) {
                    if (inputBarcodeData.current.value !== "") {
                        const inputData = inputBarcodeData.current.value.split(",");
                        jsonData.current = [];
                        jsonData.current.push({ BarCodeData: inputData[0] });
                        if (inputData.length > 1) {
                            jsonData.current[0].Name = inputData[1];
                        }
                        if (inputData.length > 2) {
                            jsonData.current[0].Model = inputData[2];
                        }
                        if (inputData.length > 3) {
                            jsonData.current[0].LableName = inputData[3];
                        }
                        if (inputData.length > 4) {
                            jsonData.current[0].Serial = inputData[4];
                        }
                        if (inputData.length > 5) {
                            jsonData.current[0].QRCodeData = inputData[5];
                        }
                    }
                }
                for (let j = 0; j < jsonData.current.length; j++) {
                    for (let i = 0; i < printCount; i++) {
                        printData.push(jsonData.current[j]);
                    }
                }


                dataSet.readJson(JSON.stringify(printData));
                report.regData("ds" + reportName.current, "ds" + reportName.current, dataSet);
                report.reportAlias = reportName.current;
                report.dictionary.synchronize();
                if (!e.ctrlKey) {
                    const viewOptions = new window.Stimulsoft.Viewer.StiViewerOptions();
                    viewOptions.appearance.fullScreenMode = true;
                    viewOptions.appearance.scrollbarsMode = true;
                    viewOptions.toolbar.showViewModeButton = true;
                    viewOptions.toolbar.printDestination = window.Stimulsoft.Viewer.StiPrintDestination.Direct;
                    const viewer = new window.Stimulsoft.Viewer.StiViewer(viewOptions, "StiViewer", false);
                    viewer.report = report;
                    viewer.renderHtml("printDesigner");
                    var userButton = viewer.jsObject.SmallButton("userButton", "بازگشت", "emptyImage");
                    userButton.style["font-family"] = "Vazir";
                    userButton.style["color"] = "blue";
                    userButton.image.src = icons8;
                    userButton.action = closePrint

                    var toolbarTable = viewer.jsObject.controls.toolbar.firstChild.firstChild;
                    var buttonsTable = toolbarTable.rows[0].firstChild.firstChild;
                    var userButtonCell = buttonsTable.rows[0].insertCell(0);
                    userButtonCell.className = "stiJsViewerClearAllStyles";
                    userButtonCell.appendChild(userButton);
                }
                else {
                    const options = new window.Stimulsoft.Designer.StiDesignerOptions();
                    options.appearance.fullScreenMode = true;
                    options.appearance.htmlRenderMode = window.Stimulsoft.Report.Export.StiHtmlExportMode.Div;
                    const designer = new window.Stimulsoft.Designer.StiDesigner(options, "Designer", false);
                    designer.onSaveReport = function (e) {
                        const jsonStr = e.report.saveToJsonString();
                        savePrintReport(reportName.current, jsonStr);
                    }
                    designer.report = report;
                    designer.renderHtml("printDesigner");
                    designer.jsObject.options.images["ImageBack"] = backWhite;
                    var toolBarRow = designer.jsObject.options.toolBar.firstChild.tr[0];
                    var customButton = designer.jsObject.StatusPanelButton("btnBack", "بازگشت", "ImageBack", null, null, 30, 30);
                    customButton.action = closePrint;
                    customButton.style["font-family"] = "Vazir";
                    customButton.style["color"] = "white";
                    var buttonCell = document.createElement("td");
                    buttonCell.className = "stiDesignerToolButtonCell";
                    buttonCell.appendChild(customButton);
                    toolBarRow.insertBefore(buttonCell, toolBarRow.childNodes[0]);
                }
            });
        }
        loadPrintReport(reportName.current, false, onGetReport);
    }
    useEffect(() => {
        if (show) {
            getPrintTemplateList("Barcode", setPrintTemplates);
        }
    }, [show])
    return (
        <Modal show={show} onHide={() => { }} size={modalSize} autoFocus={false} >
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faBarcode} size="lg" />&nbsp;چاپ بارکد
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle" style={{ paddingTop: "8px", minHeight: modalSize === "xl" ? "85vh" : "" }}>
                {error && <Alert variant="danger"><ExclamationTriangle size={23} />&nbsp;{error}</Alert>}
                <div style={{ color: "blue" }}><input type="checkbox" className="form-check-input" onChange={e => setShowInputFile(e.target.checked)} />&nbsp;دریافت اطلاعات از فایل</div>
                <Row className="mt-0">
                    {showInputFile ?
                        <FormGroup className="col-md-8">
                            <label>فایل اطلاعات:</label>
                            <input type="file" className="form-control" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" onChange={getUploadedFile} />
                        </FormGroup> :
                        <FormGroup className="col-md-8">
                            <label>اطلاعات بارکد:</label>
                            <Form.Control ref={inputBarcodeData} />
                        </FormGroup>}
                    <FormGroup className="col-md-4">
                        <label>تعداد چاپ:</label>
                        <Form.Control type="number" defaultValue={1} ref={inputPrintCount} />
                    </FormGroup>
                    {showNewPrint ?
                        <FormGroup>
                            <Form.Control ref={inputNewReportName} placeholder="نام فایل را انگلیسی وارد کنید" />
                            <Button className="btn-input-tiny" onClick={addNewBarcodePrint} variant="success" style={{ left: 50, top: 8 }}><Check2Square size={23} /></Button>
                            <Button variant="danger" className="btn-input-tiny" onClick={() => { setShowNewPrint(false) }} style={{ top: 8 }}><DashCircle size={23} /></Button>
                        </FormGroup> :
                        <Fragment>
                            <FormGroup className="col-md-8">
                                <label>قالب چاپ:</label>
                                <Form.Control as="select" onChange={e => reportName.current = e.target.value}>
                                    <option value="">انتخاب کنید</option>
                                    {printTemplates?.Data?.map((item, i) => <option key={i} value={item}>{item}</option>)}
                                </Form.Control>
                            </FormGroup>
                        </Fragment>
                    }
                </Row>
                <div className="mt-2">
                    <Button className="group-Btn" variant="secondary" onClick={print}><Printer size={18} />&nbsp;چاپ بارکد</Button>
                    {!showNewPrint && <Button className="group-Btn" title="قالب چاپ جدید" variant="info" onClick={() => setShowNewPrint(true)}><PlusSquare size={18} />&nbsp;چاپ جدید</Button>}
                </div>
                <hr />
                <label style={{ color: "red", fontSize: "12px" }}>بارکد|نام|مدل|برچسب|سریال|QRCode</label>
                <div id="printDesigner" style={{ direction: "ltr", display: showPrint ? "block" : "none" }}></div>
            </Modal.Body>
        </Modal>
    )
}